import React, { Component } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./pages/Layout/Layout";
import Login from "./pages/Login/Login";
import DeviceHome from "./pages/DeviceManage/DeviceHome/DeviceHome";
import PaiXiang from "./pages/DeviceManage/PaiXiang/PaiXiang";
import CommandIssued from "./pages/DeviceManage/CommandIssued/CommandIssued";
import BatchList from "./pages/DeviceManage/CommandIssued/BatchList";
import Authorization from "./pages/SystemManage/Authorization/Authorization";
import Role from "./pages/SystemManage/Role/Role";
import LargeScreen from "./pages/LargeScreen/LargeScreen";
import ErrorPage from "./pages/Error/ErrorPage";
import History from "./pages/DeviceManage/History/History";
import PressureMeasurement from "./pages/DeviceManage/PressureMeasurement/PressureMeasurement";

class App extends Component {
  render() {
    return (
      <>
        <Routes>
          <Route path="/Login" element={<Login />} />
          <Route path="/" element={<Layout />}>
            <Route path="device/DeviceHome" element={<DeviceHome />} />
            <Route path="device/CommandIssued" element={<CommandIssued />} />
            <Route path="device/BatchList" element={<BatchList />} />
            <Route path="device/History" element={<History />} />
            <Route
              path="device/PressureMeasurement"
              element={<PressureMeasurement />}
            />
            <Route path="device/PaiXiang" element={<PaiXiang />} />
            <Route path="system/Authorization" element={<Authorization />} />
            <Route path="system/Role" element={<Role />} />
            <Route path="/" element={<DeviceHome />} />
          </Route>
          <Route path="/LargeScreen" element={<LargeScreen />} />
          <Route path="*" element={<ErrorPage />} />
        </Routes>
      </>
    );
  }
}

export default App;
